export default {

		api_url: (process.env.NODE_ENV==='production')? location.protocol+'//userauthapis.xbees.in/api/':location.protocol+'//stageusermanagementapi.xbees.in/api/',
		mapKey : (process.env.NODE_ENV==='production') ? '' : 'pk.eyJ1IjoicHJhbmF2a3VsNDYiLCJhIjoiY2tjMnlmZ2ZrMDFzMDJybGRubTR6cWxhaSJ9.JOVtxSST0rEEhNaOLXchGQ',
		iptracker_url:(process.env.NODE_ENV==='production') ?location.protocol+'//track.xbees.in/api/':location.protocol+'//stageiptracking.xbees.in/api/',
		secretkey : (process.env.NODE_ENV==='production') ? 'Bearer PoBkksV8o7obqtmSYvEeeHggdIn9izyU0nJQTbcrRr0' : 'Bearer SjjeRSlo82#cmejdc$$o0pxABWnQrlhcxxb',


}



// WEBPACK FOOTER //
// ./src/constants.js